//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('categoriesController', ['$scope', 'authService', '$sce', 'categories', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state',
      function ($scope, authService, $sce, categories, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, $state) {
        const progress = progressBar.getProgressBar();
        $scope.viewData = {};
        $scope.category = {
          Id: 0,
          Name: ''
        };
        $scope.isEdit = false;

        const id = $stateParams.id;
        if (!!id) {

          progress.start();
          categories.getCategoryById(id).then(function (categoryDetails) {

            $scope.category = categoryDetails.data[0];
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;                     
                  $scope.errTitle = 'Get Category Error';
                },],
              });
            }
          })
          .finally(function () {
            progress.complete();
          });

          $scope.isEdit = true;
        };

        $scope.saveCategory = function () {
          if ($scope.categoryForm.$valid) {
            addCategory($scope.category);
          }
        };

        function addCategory(category) {
          categories.addCategory(category).then(function () {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Category Success';
                $scope.successMsg = 'The category has been added succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.categories');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Save Category Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };

        $scope.clearAll = function () {
          $scope.isEdit = false;
          $scope.isNew = false;
          $scope.category = {};
          $scope.categoryForm.$setPristine();
        };

        $scope.updateCategory = function (id) {
          if ($scope.categoryForm.$valid) {
            const category = $scope.category;
            putCategory(category);
          };
        };

        function putCategory(category) {
          categories.updateCategory(category.Id, category).then(function (category) {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Update Category Success';
                $scope.successMsg = 'The category has been updated succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.categories');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'dlg-template-category',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.categoryError = err.statusText + ' ' + err.data;
                  $scope.messageTitle = 'Update Category Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        }

        //ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            visible: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };

        $scope.onDblClick = function (row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view(row.entity);
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        function setGridData() {
          progress.start();
          categories.getCategories().then(function (arrCategories) {
            const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            $scope.gridOptions.data = arrCategories.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
            $scope.gridOptions.totalItems = arrCategories.data.length;
          }).finally(function () {
            progress.complete();
          });
        };
        setGridData();
        $scope.view = function (rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.viewData.name = selectedRow.Name;
            $scope.viewData.id = selectedRow.Id;

            const view = ngDialog.open({
              template: 'templates/partials/viewCategory.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function (data) {
              $scope.viewData = {};
            });
          }
        };
        $scope.deleteCategory = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Category?';
              $scope.strMsg = 'Do you really want to delete this category?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              categories.deleteCategory($scope.rowSelectingId).then(function (response) {                
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Delete Category Success';
                    $scope.successMsg = 'The category has been succesfully deleted.';
                  },],
                });
                dialog.closePromise.then(function (data) { });
              }, function (err) {
                if (err.status != 401) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                      $scope.errTitle = 'Delete Category Error';
                    },],
                  });
                  dialog.closePromise.then(function (data) { });
                }
              })
                .finally(function () {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function () {
          $state.go('app.editCategory', {
            id: $scope.rowSelectingId,
          });
        };

      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/categoriesController.js